import React from 'react';
import { IconProps } from '../types';
const MinecraftLead: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="2" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(181, 168, 159, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(166, 155, 147, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(166, 155, 147, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(114, 96, 84, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(133, 70, 27, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(166, 103, 61, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(174, 115, 75, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(139, 112, 95, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(94, 47, 16, 255)" />
</svg>);
export default MinecraftLead;